// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/fr-BE';

import createAccount from './createAccount';

createAccount(i18n);
